import React from 'react'
import { useNavigate } from 'react-router-dom';

function Confirmation() {
    const navigate = useNavigate()
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="relative mx-5 max-w-3xl lg:w-[500px] lg:mx-auto my-6">
          <div className="relative  flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none  p-3">
            <div className="mx-auto">
              <p className="font-bold text-center my-6">
                تمت إضافة طلبك بنجاح , سيتم مراجعة المزاد من قبل الإدارة للتأكيد
              </p>
              <div className="flex justify-center gap-4 my-4">
                <button
                  onClick={() => {
                    navigate('/home/cropsAuction')
                  }}
                  className="border-primary bg-primary text-white rounded-[13px] border px-[38.5px] py-2 "
                >
                  موافق
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="fixed inset-0 z-40 bg-black opacity-25"
        onClick={() => {
        navigate("/home/cropsAuction");
        }}
      ></div>
    </>
  );
}

export default Confirmation